import * as React from 'react';
import toArray from 'rc-util/lib/Children/toArray';
export function parseChildren(children, keyPath) {
    return toArray(children).map((child, index) => {
        var _a, _b;
        if (React.isValidElement(child)) {
            const { key } = child;
            let eventKey = (_b = (_a = child.props) === null || _a === void 0 ? void 0 : _a.eventKey) !== null && _b !== void 0 ? _b : key;
            const emptyKey = eventKey === null || eventKey === undefined;
            if (emptyKey) {
                eventKey = `tmp_key-${[...keyPath, index].join('-')}`;
            }
            const cloneProps = {
                key: eventKey,
                eventKey
            };
            if (process.env.NODE_ENV !== 'production' && emptyKey) {
                cloneProps.warnKey = true;
            }
            return React.cloneElement(child, cloneProps);
        }
        return child;
    });
}
/**
 * 如果是带icon的submenu，则将 children className 更新为 'item-with-icon'。
 * 如果 subStyle 中存在 paddingLeft，则将其传递给子元素的 sub 属性。
 *
 * @param children submenu 的子元素
 * @param className submenu 的 className
 * @param style submenu title 的 style
 * @returns React.ReactNode[] 返回一个包含修改后的子元素的数组
 */
export function parseChildrenWithIcon(children, className, subStyle) {
    return toArray(children).map(child => {
        if (React.isValidElement(child)) {
            const subWithIcon = className === null || className === void 0 ? void 0 : className.includes('submenu-with-icon');
            const cloneProps = Object.assign(Object.assign({}, (subWithIcon ? { className: 'item-with-icon' } : {})), ((subStyle === null || subStyle === void 0 ? void 0 : subStyle.paddingLeft) ? { sub: subStyle.paddingLeft } : {}));
            return React.cloneElement(child, cloneProps);
        }
        return child;
    });
}
